<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: "",
    },
    count: {
      type: Number
    },
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {},
};
</script>

<template>
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
      <div
        class="mb-2 d-flex align-items-center justify-content-between"
      >
        <h4 class="mb-0 font-size-18">{{ $t(title) }} {{ $t(count) }}</h4>

        <div class="page-title-right">
          <!-- <ol class="breadcrumb m-0">
            <li class="breadcrumb-item" v-for="(item, index) in items" :key="index">
              <a href="#" target="_self" class="">{{ $t(item.text) }}</a>
            </li>
          </ol> -->
        </div>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>
